export default __webpack_public_path__ + "static/media/facebook-header.ba7b0464.svg";